import { render, staticRenderFns } from "./ArchiveProduct.vue?vue&type=template&id=d58399fe"
import script from "./ArchiveProduct.vue?vue&type=script&lang=js"
export * from "./ArchiveProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d58399fe')) {
      api.createRecord('d58399fe', component.options)
    } else {
      api.reload('d58399fe', component.options)
    }
    module.hot.accept("./ArchiveProduct.vue?vue&type=template&id=d58399fe", function () {
      api.rerender('d58399fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/ArchiveProduct.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArchiveProduct.vue
// module id = 81
// module chunks = 0